import api from './api'

export interface Evaluation {
  id: string
  studentId: string
  gridId: string
  criteriaId: string
  score: number
  comment?: string
  evaluatedAt: string
  evaluatedBy: string
}

export interface CreateEvaluationDto {
  studentId: string
  gridId: string
  criteriaId: string
  score: number
  comment?: string
}

export interface EvaluationSession {
  id: string
  gridId: string
  name: string
  date: string
  evaluations: Evaluation[]
}

const evaluationService = {
  async getAll(): Promise<EvaluationSession[]> {
    const response = await api.get('/api/evaluations-v2')
    if (response.sessions && Array.isArray(response.sessions)) {
      return response.sessions
    }
    if (Array.isArray(response)) {
      return response
    }
    return []
  },

  async create(data: CreateEvaluationDto): Promise<Evaluation> {
    const response = await api.post('/api/evaluations-v2', data)
    return response.evaluation || response
  },

  async update(id: string, data: Partial<CreateEvaluationDto>): Promise<Evaluation> {
    const response = await api.put(`/api/evaluations-v2/${id}`, data)
    return response.evaluation || response
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/evaluations-v2/${id}`)
  }
}

export default evaluationService
